// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1g8Cx","right":"styles_right__16wms"};